import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  @Input() isLoading?: boolean;
  @Input() errored?: boolean;
  @Input() minimal?: boolean;
  @Input() noPadding?: boolean;
  @Input() diameter = 50;

  reload() {
    window.location.reload();
  }
}
